interface Props {
  value: string;
}
const CalculatorDisplay: React.FC<Props> = ({ value }) => (
  <div className="calculator-display">{value || "0"}</div>
);
export default CalculatorDisplay;
